export default __webpack_public_path__ + "static/media/01-2.2d50127d.jpg";